import { PropRow, Toggle } from '../../ui/controls.js';
import type { SettingsSectionProps } from '../settings-types.js';
import { applyQualityPreset, isObj, matchQualityPreset, QUALITY_PRESETS, taaEnabled, withTaa } from '../settings-validate.js';

/**
 * Quality presets (Unity's quality levels as one-click fills): each button
 * writes its values into `settings.quality` and switches temporal AA, which
 * lives in the project post-processing defaults.
 */
export function QualityPresets({ value, settings, update }: SettingsSectionProps) {
  const quality = isObj(value) ? value : undefined;
  const current = matchQualityPreset(quality);
  const taa = taaEnabled(settings.render);
  return (
    <>
      <div className="settings-presets" role="group" aria-label="Quality presets">
        {QUALITY_PRESETS.map((preset) => (
          <button
            key={preset.id}
            type="button"
            className={`settings-preset${current === preset.id ? ' is-active' : ''}`}
            aria-pressed={current === preset.id}
            title={`Fill the quality settings with the ${preset.label} preset${preset.taa ? ' (temporal AA on)' : ''}`}
            onClick={() =>
              update(
                { quality: applyQualityPreset(quality, preset), render: withTaa(settings.render, preset.taa) },
                `Quality preset: ${preset.label}`,
              )
            }
          >
            {preset.label}
          </button>
        ))}
        <span className="settings-preset-state muted">{current ? '' : 'Custom'}</span>
      </div>
      <PropRow label="Temporal AA" hint="settings.render.postProcess.temporalAntiAliasing.enabled: removes shimmer on foliage, wires and thin edges">
        <Toggle
          checked={taa}
          onChange={(on) => update({ render: withTaa(settings.render, on) }, on ? 'Enable temporal AA' : 'Disable temporal AA')}
        />
      </PropRow>
    </>
  );
}
